import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { LightHeaderModel } from './models/lightHeader.model';
import useStickyWrapper from '../../hooks/useStickyWrapper';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { documentService } from '../../utils/window.utils';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import LanguageSelector from './components/languageSelector';
import Logo from './components/logo';

const LightHeaderWrapper = (props): any => {
  const model = new LightHeaderModel(props);
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props.sitecoreContext.pageState === 'preview';
  const isSticky = !(isEEActive || isPreview);

  const [navigationVisibility, setNavigationVisibility] = useState(false);

  useEffect(() => {
    // set height as css property so that content can be shifted below
    if (isSticky) {
      documentService()?.body.style.setProperty('--pfe-navigation--Height--actual', '85px');
    }
    setNavigationVisibility(true);
    const loadingDiv = documentService()?.getElementById('loading');
    if (loadingDiv) {
      loadingDiv.remove();
      const rootElement = documentService()?.getElementById('loading');
      if (rootElement) rootElement.style.display = 'none';
    }
    return (): void => {
      documentService()?.body.style.removeProperty('--pfe-navigation--Height--actual');
    };
  }, [isSticky]);

  const baseClassName = 'lightheader-navigation';
  const wrapperClassName =
    baseClassName + (isEEActive ? ' ' + baseClassName + '--EE-active' : '') + (isPreview ? ' ' + baseClassName + '--preview' : '');

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className={wrapperClassName} hidden={!navigationVisibility}>
      <nav className="lightheader-navigation__container">
        <Logo logoImage={model.logoImage} mobileLogoImage={model.mobileLogoImage} logoLink={model.logoLink} />
        <div className="lightheader-navigation__item-wrapper">{model.items?.length > 0 && <LanguageSelector items={model.items} />}</div>
      </nav>
    </div>
  );
};

const LightHeader = (props): JSX.Element | null => {
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props?.sitecoreContext?.pageState === 'preview';
  const isEE = isEEActive || isPreview;

  const stickyWrapperEle = useStickyWrapper();

  if (isEE) return <LightHeaderWrapper {...props} />;

  if (!stickyWrapperEle) return null;

  return createPortal(<LightHeaderWrapper {...props} />, stickyWrapperEle);
};

export default withSitecoreContext()(LightHeader);
